import { Box, Chip, Tooltip } from "@mui/material"
import type { ChipProps } from "@mui/material"
import { KeyboardArrowDownOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { getVersionStatusColor } from "../utils/productVersion"

import type { ProductVersionInfo } from "@/graphql/codegen/graphql"
import { formatDate } from "@/utils/date"

interface ProductVersionChipProps {
  version: ProductVersionInfo | undefined
  isInteractive?: boolean
  isTooltipVisible?: boolean
  onClick?: () => void
  onDelete?: () => void
  deleteIcon?: ChipProps["deleteIcon"]
  tooltipTitle?: string
  anchorRef?: React.RefObject<HTMLDivElement>
}

export const ProductVersionChip: FC<ProductVersionChipProps> = ({
  version,
  isInteractive = false,
  isTooltipVisible = false,
  onClick,
  onDelete,
  deleteIcon = <KeyboardArrowDownOutlined className='text-gray-800' />,
  tooltipTitle,
  anchorRef,
}) => {
  const chip = (
    <Chip
      avatar={
        <Box className={`flex w-fit items-center justify-center rounded p-1 ${getVersionStatusColor(version?.status)}`}>
          v{version?.versionNumber}
        </Box>
      }
      label={<span className='px-1'>{formatDate(version?.releaseDate ?? "")}</span>}
      variant='filled'
      size='small'
      className='rounded bg-gray-100 text-gray-900'
      ref={anchorRef}
      {...(isInteractive && {
        onClick,
        deleteIcon,
        onDelete,
      })}
    />
  )

  return isTooltipVisible ? (
    <Tooltip title={tooltipTitle}>
      <span>{chip}</span>
    </Tooltip>
  ) : (
    chip
  )
}
